import { render, staticRenderFns } from "./CouponTag.vue?vue&type=template&id=5eec3806&scoped=true"
import script from "./CouponTag.vue?vue&type=script&lang=js"
export * from "./CouponTag.vue?vue&type=script&lang=js"
import style0 from "./CouponTag.vue?vue&type=style&index=0&id=5eec3806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eec3806",
  null
  
)

export default component.exports